import React from 'react'
import { Grid, IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, palette, spacing }) => ({
  root: {
    padding: spacing(3, 5),
    boxShadow: '0px 1px 2px 0px #18181812'
  },
  title: {
    fontWeight: typography.fontWeightBold,
    ...typography.body.m
  },
  icon: {
    color: palette.text.primary
  }
}))

const Header = ({ title, onClose }) => {
  const classes = useStyles()

  return (
    <Grid
      container
      item
      justifyContent='space-between'
      alignItems='center'
      className={classes.root}
    >
      <Typography
        component='h2'
        className={classes.title}
        data-test='lpq-header-title'
      >
        {title}
      </Typography>
      <IconButton
        onClick={() => onClose('close-button')}
        data-test='lpq-header-close-button'
        aria-label='close'
        size='large'
      >
        <Close className={classes.icon} />
      </IconButton>
    </Grid>
  )
}

export default Header
